module.exports = __webpack_public_path__ + "img/google_logo.695a3160.svg";